module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/2-5e5ef55367f5830831385a04f49db93f.svg";